(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const collectionUrl = new URL(window.location.href);

  if (collectionUrl.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(collectionUrl.hash.slice(1));

        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  const initializeProductScrollAnimations = () => {
    const resultsLists = document.querySelectorAll('results-list');

    resultsLists.forEach((resultsList) => {
      if (resultsList.dataset.scrollAnimationInitialized === 'true') return;

      resultsList.dataset.scrollAnimationInitialized = 'true';

      const productObserver = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            entry.target.classList.add(
              'product-scroll-animation--visible'
            );

            observer.unobserve(entry.target);
          });
        },
        {
          threshold: 0.08,
          rootMargin: '0px 0px 80px 0px'
        }
      );

      const observeProductCards = () => {
        const cards = resultsList.querySelectorAll(
          '.product-grid__item:not([data-animation-ready])'
        );

        cards.forEach((card, index) => {
          card.dataset.animationReady = 'true';
          card.classList.add('product-scroll-animation');

          card.style.setProperty(
            '--product-animation-delay',
            `${(index % 4) * 70}ms`
          );

          productObserver.observe(card);
        });
      };

      observeProductCards();

      const gridMutationObserver = new MutationObserver(() => {
        observeProductCards();
      });

      gridMutationObserver.observe(resultsList, {
        childList: true,
        subtree: true
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeProductScrollAnimations,
      { once: true }
    );
  } else {
    initializeProductScrollAnimations();
  }

  document.addEventListener(
    'shopify:section:load',
    initializeProductScrollAnimations
  );

  } catch(e) { console.error(e); }
})();
})();
